import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const BudgetDuringInspectionSectionGridItem = ({ dataCy, labelId, valueId }) => {
  return (
    <div className="flex flex-col w-full" data-cy={dataCy}>
      <div className="font-bold">
        <FormattedMessage id={labelId} />
      </div>
      <FormattedMessage id={valueId} />
    </div>
  );
};

BudgetDuringInspectionSectionGridItem.propTypes = {
  dataCy: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  valueId: PropTypes.string.isRequired,
};

export default BudgetDuringInspectionSectionGridItem;
